import { useState } from "react";
import { createSubscriber } from "../../../controllers/subscribersController";
import logo from "../../../assets/mascot.png";
export default function SubscribeModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [apiError, setApiError] = useState("");

  if (!isOpen) return null;

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email is invalid";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setApiError("");
      return;
    }

    setErrors({});
    setApiError("");
    setIsSubmitting(true);

    try {
      await createSubscriber(formData.email, formData.fullName);

      setIsSuccess(true);
      setTimeout(() => {
        onClose();
        resetForm();
      }, 2000);
    } catch (err) {
      setApiError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({ fullName: "", email: "" });
    setErrors({});
    setApiError("");
    setIsSuccess(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <div
            className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white dark:bg-[#12151f] shadow-2xl transition-all border border-gray-200 dark:border-gray-800"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition z-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>

            <div className="grid md:grid-cols-1 gap-0">
              {/* Left Side: Logo/Image */}
              {/* <div className="hidden md:flex items-center justify-center bg-gradient-to-br  p-8 rounded-l-2xl">
                
              </div> */}

              {/* Right Side: Form */}
              <div className="p-6 md:p-8 lg:p-10">
                {/* Header */}

                {!isSuccess && (
                  <div className="mb-6">
                    <div className="text-center mb-6 flex items-center justify-center gap-4 ">
                      <div className="w-12">
                        <img
                          src={logo}
                          alt="Brand Logo"
                          className="w-full h-auto object-contain drop-shadow-lg"
                        />
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">
                        Join the Reels Insider Club
                      </h3>
                    </div>
                    <p className="text-sm">
                      Be the first to catch our exclusive weekly drops, discount
                      codes, and creator highlights delivered straight to your
                      inbox
                    </p>
                  </div>
                )}

                {/* API Error Alert */}
                {apiError && !isSuccess && (
                  <div className="mb-4 p-3 bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 rounded-xl text-sm">
                    {apiError}
                  </div>
                )}

                {/* Success Message */}
                {isSuccess ? (
                  <div className="text-center py-8">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      fill="currentColor"
                      className="bi bi-check-circle-fill text-green-500 dark:text-green-400 mx-auto mb-3"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <p className="text-sm text-green-600 dark:text-green-400">
                      You’re in! 🎉 Thanks for subscribing to the Reels Insider
                      Club. Keep an eye on your inbox for weekly updates,
                      exclusive discounts, and early access to Reels promos.
                    </p>
                  </div>
                ) : (
                  <>
                    {/* Form */}

                    <form onSubmit={handleSubmit} className="space-y-4">
                      {/* Full Name */}
                      <div>
                        <input
                          type="text"
                          id="fullName"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          className={`w-full px-4 py-2 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 transition-colors ${
                            errors.fullName
                              ? "border-red-500 dark:border-red-500"
                              : "border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-[#1e2430]"
                          }`}
                          placeholder="John Doe"
                        />
                        {errors.fullName && (
                          <p className="mt-1 text-xs text-red-600 dark:text-red-400">
                            {errors.fullName}
                          </p>
                        )}
                      </div>

                      {/* Email Address */}
                      <div>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`w-full px-4 py-2 border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 transition-colors ${
                            errors.email
                              ? "border-red-500 dark:border-red-500"
                              : "border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-[#1e2430]"
                          }`}
                          placeholder="you@example.com"
                        />
                        {errors.email && (
                          <p className="mt-1 text-xs text-red-600 dark:text-red-400">
                            {errors.email}
                          </p>
                        )}
                      </div>

                      {/* Submit Button */}
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full py-3 px-4 rounded-full font-semibold text-white transition-all flex items-center justify-center shadow-md ${
                          isSubmitting
                            ? "bg-blue-500 opacity-75 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                        }`}
                      >
                        {isSubmitting ? (
                          <>
                            <svg
                              className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Subscribing...
                          </>
                        ) : (
                          "Subscribe & Unlock Access"
                        )}
                      </button>
                    </form>

                    {/* Cancel Link */}
                    <p
                      onClick={onClose}
                      className="w-full mt-3 py-2 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition"
                    >
                      We respect your inbox — no spam, only good vibes.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
